/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TodayCommunityGamesStatus {
  finished = 'finished',
  live = 'live',
  upcoming = 'upcoming'
}

/**
 * TodayCommunityGamesStatus
 *
 * Todays community games status
 */
export const TodayCommunityGamesStatusEnumType = types.enumeration('TodayCommunityGamesStatus', [
  'finished',
  'live',
  'upcoming'
])
